/* Bilingual content for Cart page */

export const CART_CONTENT = {
  en: {
    yourCart: "Your cart",
    cartEmpty: "Your cart is empty.",
    startEligibility: "Start your eligibility check",
    alreadyHaveAccount: "Already have an account?",
    signIn: "Sign In",
    qty: "Qty",
    remove: "Remove",
    deliveryAddress: "Delivery Address",
    streetAddress: "Street Address",
    addressPlaceholder: "Start typing your address...",
    addressError: "Please enter a valid delivery address",
    total: "Total",
    proceedToCheckout: "Proceed to checkout",
    continueShopping: "Continue shopping",
  },
  es: {
    yourCart: "Tu carrito",
    cartEmpty: "Tu carrito está vacío.",
    startEligibility: "Comienza tu verificación de elegibilidad",
    alreadyHaveAccount: "¿Ya tienes una cuenta?",
    signIn: "Iniciar Sesión",
    qty: "Cant",
    remove: "Eliminar",
    deliveryAddress: "Dirección de Entrega",
    streetAddress: "Dirección",
    addressPlaceholder: "Comienza a escribir tu dirección...",
    addressError: "Por favor ingresa una dirección de entrega válida",
    total: "Total",
    proceedToCheckout: "Proceder al pago",
    continueShopping: "Continuar comprando",
  },
};

export function getCartContent(lang) {
  return CART_CONTENT[lang] || CART_CONTENT.en;
}
